"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationService = void 0;
const configs_1 = require("../../configs/configs");
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
/**
 * @TODO: Refactor this service: move logic in validator and validation renderer services.
 */
class ValidationService {
    constructor(validationCriteria) {
        this.validationCriteria = validationCriteria;
    }
    validateInputs(config, withErrorDisplay = false, context = null) {
        let results = [];
        // Go through each input for the step
        for (let i = 0; i < config.length; i++) {
            let inputRule = config[i];
            let validationResult;
            if (!withErrorDisplay) {
                validationResult = this.validateWithoutTriggeringErrors(inputRule, context);
            }
            else {
                validationResult = this.validateInput(inputRule, context);
            }
            results.push(validationResult);
        }
        return results.indexOf(false) === -1;
    }
    validateInput(inputRule, context) {
        context = context || document;
        let results = [];
        // Select the input
        let input = context.querySelector(inputRule.inputId);
        if (!this.shouldValidate(inputRule, context)) {
            return true;
        }
        if (!input || input.disabled) {
            return false;
        }
        input.classList.remove(configs_1.configs.utilityCSSClasses.isInvalid);
        input.classList.add(configs_1.configs.utilityCSSClasses.isValid);
        inputRule.criteria.forEach((criteria) => {
            // Assume that the criteria is passed and make sure the error message is in it's default config i.e. invisivble
            if (criteria.errorMessageId) {
                let message = context.querySelector(criteria.errorMessageId);
                if (message) {
                    message.classList.remove('is-visible');
                }
            }
        });
        // Go through each criteria defined for that input
        for (let i = 0; i < inputRule.criteria.length; i++) {
            let criteria = inputRule.criteria[i];
            let criteriaStatus = this.validationCriteria.evaluateCriteria(input, criteria);
            results.push(criteriaStatus);
            if (criteriaStatus === false) {
                input.classList.add(configs_1.configs.utilityCSSClasses.isInvalid);
                input.classList.remove(configs_1.configs.utilityCSSClasses.isValid);
                if (criteria.errorMessageId) {
                    let message = context.querySelector(`[${configs_1.configs.dataAttribute.validationMessage}="${input.name}:${criteria.errorMessageId}"]`);
                    if (message) {
                        message.classList.add('is-visible');
                    }
                    else {
                        console.warn(`Error message with selector '${criteria.errorMessageId}' not found.`);
                    }
                }
                break;
            }
        }
        return results.indexOf(false) === -1;
    }
    validateWithoutTriggeringErrors(inputRule, context) {
        context = context || document;
        let results = [];
        // Select the input
        let input = context.querySelector(inputRule.inputId);
        if (!this.shouldValidate(inputRule, context)) {
            return true;
        }
        if (!input || input.disabled) {
            return false;
        }
        // Go through each criteria defined for that input
        for (let i = 0; i < inputRule.criteria.length; i++) {
            let criteria = inputRule.criteria[i];
            let criteriaStatus = this.validationCriteria.evaluateCriteria(input, criteria);
            results.push(criteriaStatus);
            if (criteriaStatus === false) {
                break;
            }
        }
        return results.indexOf(false) === -1;
    }
    shouldValidate(inputRule, context) {
        if (!inputRule.when) {
            return true;
        }
        let validate = true;
        for (let [fieldName, value] of Object.entries(inputRule.when)) {
            const field = context.querySelector(`[name="${fieldName}"]`);
            if (!field) {
                throw new WidgetError_1.default(`Field '${fieldName}' not found for 'when' option on input validation '${inputRule.inputId}'.`);
            }
            if (value instanceof RegExp) {
                validate = validate && value.test(this.getFieldValue(field, context));
            }
            else {
                validate = validate && value == this.getFieldValue(field, context);
            }
        }
        return validate;
    }
    getFieldValue(field, context) {
        if (field.type == "radio") {
            return context.querySelector(`[name="${field.name}"]:checked`).value;
        }
        if (field.type == "checkbox") {
            throw new WidgetError_1.default(`Not handled.`);
        }
        return field.value;
    }
}
exports.ValidationService = ValidationService;
